export const replaceTofu = (str: string) => {
  if (!str) return '';

  if (!str.trim()) {
    return '■'.repeat(str.length);
  }

  return str;
};
